import { render } from "./Form3.vue?vue&type=template&id=da70c5d8"
import script from "./Form3.vue?vue&type=script&lang=js"
export * from "./Form3.vue?vue&type=script&lang=js"

import "./Form3.vue?vue&type=style&index=0&id=da70c5d8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__